import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13c61dab&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./index.vue?vue&type=style&index=0&id=13c61dab&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=13c61dab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c61dab",
  null
  
)

export default component.exports